import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// next
import { useRouter } from 'next/router';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_REGISTER } from '../routes/paths';
// components
import {
  Backdrop,
  CircularProgress,
} from '@mui/material';
// utils
import axios from 'axios';
import { isValidToken, setSession } from '../utils/jwt';

// ----------------------------------------------------------------------

DefaultLoginGuard.propTypes = {
  children: PropTypes.node,
};

export default function DefaultLoginGuard({ children }) {
  const { push, pathname, query, asPath } = useRouter();
  const { user, getUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const getNewQuery = (query) => {
    const newQuery = {
      ...query,
    };
    delete newQuery.ek;
    delete newQuery.ev;
    return newQuery;
  };

  const getUserByToken = async (ek, ev) => {
    setIsLoading(true);
    const accessToken = window.localStorage.getItem('accessToken');
    if (accessToken && isValidToken(accessToken)) {
      setSession(accessToken);
      try {
        await getUser();
      } catch (error) {
        // 에러 발생 시 로그아웃 처리 후 재시도
        setSession(null);
        await getUserByToken(ek, ev);
        return;
      }
      setIsLoading(false);
      push({ pathname, query: getNewQuery(query) }, undefined, { shallow: true });
    } else {
      try {
        const res = await axios.post(`${process.env.HOST_API_KEY}/api/accounts/ephemeral/`, {
          key: ek,
          value: Number.parseInt(ev),
        });
        setSession(res.data.t);
        push({ pathname, query: getNewQuery(query) }, undefined, { shallow: true });
        await getUser();
        if (window.dataLayer) {
          window.dataLayer.push({'user_id': user.id, "event": "setUserId"});
        };
        setIsLoading(false);
      } catch (error) {
        push({
          pathname: PATH_AUTH.login,
          query : {
            ...getNewQuery(query),
            from: asPath,
          },
        });
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (!user) {
      if (query.ek && query.ev) {
        getUserByToken(query.ek, query.ev);
      } else {
        push({
          pathname: PATH_AUTH.login,
          query : {
            ...query,
            from: asPath,
          },
        });
      }
    } else if (user && !user.is_employee) {
      if (window.dataLayer) {
        window.dataLayer.push({'user_id': user.id, "event": "setUserId"});
      }
      push({
        pathname: PATH_REGISTER.position,
        query
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, query]);

  return (
    <>
      {children}
      <Loading open={isLoading} />
    </>
  );
};

function Loading({ open }) {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
